import { Component, inject } from "@angular/core";
import { ROLE_MAP_CONFIG } from "@peca/backoffice/roles.config";

@Component({
    templateUrl: './anymarket.component.html',
    styleUrls: ['./anymarket.component.scss'],
    standalone: false,
})
export class AnyMarketComponent {
    readonly roles = inject(ROLE_MAP_CONFIG);
}
